import React from 'react';
import { Flex, Input, Form, message, Divider, Button, Upload, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getCurrentShopId } from '../shop/get-current-shop';
import PageEditor from './page-editer/editor';
import {JsonEditor, githubDarkTheme} from 'json-edit-react';
import './page-editer/dialog/dialog.css';

export default (props) => {
    console.log('=======globale, props', props)
    const [shopId, setShopId] = React.useState(null);
    const imageUrlPrefix = '//img.yxdj.tech/';
    const params = new URLSearchParams(window.location.search);
    const [form] = Form.useForm();
    const [loading, setLoading] = React.useState(false);
    const [imageUrl, setImageUrl] = React.useState();
    const [shareSmallImg, setShareSmallImg] = React.useState([]);
    const [shareLargeImg, setShareLargeImg] = React.useState([]);
    const [sharePosterImg, setSharePosterImg] = React.useState([]);
    const [pageCtn, setPageCtn] = React.useState({
        load: false,
        content: null
    });
    const pageContentRef = React.useRef(null);
    const handleChange = (fieldName, {file, fileList}) => {
        // console.log(file.status, fieldName, file, fileList);

        if(file.status === undefined) return false;

        if(file.status === 'done') {
            let thumbUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com', 'https://img.yxdj.tech');
            let imgUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com/', '');

            fileList = fileList.map((item) => {

                if(file.uid === item.uid) {
                    return { uid: item.uid, type: item.type, thumbUrl: thumbUrl + '?x-oss-process=image/resize,w_200', url: imgUrl }
                } else {
                    return item
                }
            });
        }

        if(file.status === 'done') console.log('done', fileList);

        if(fieldName === 'shareSmallImg') {
            setShareSmallImg([
                ...fileList,
            ]);
        }else if(fieldName === 'shareLargeImg') {
            setShareLargeImg([
                ...fileList,
            ]);
        }else if(fieldName === 'sharePosterImg') {
            setSharePosterImg([
                ...fileList,
            ]);
        }

        if (file.status === 'done') {
            setLoading(false);
        }else{
            if(loading === false) setLoading(true);
        }
    };

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传图片</div>
        </button>
    );

    const beforeUpload = async (file) => {
        // console.log('beforeUpload', file);
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('请上传JPG/PNG图片!');
        }
        const isLt8M = file.size / 1024 / 1024 < 8;
        if (!isLt8M) {
            message.error('图片必须小于 8MB!');
        }
        // console.log('upload', file);

        return isJpgOrPng && isLt8M;
    };

    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        fetchShopId();
    }, []);

    React.useEffect(() => {
        if (!shopId) return;
        const fetchPageContent = async () => {
            const res = await getPageContent();
            console.log('res', res?.content);
            if (res?.content) {
                try {
                    res.content = JSON.parse(res.content);
                } catch (e) {}
            }
            pageContentRef.current = res?.content;
            setPageCtn({
                load: true,
                content: res?.content
            })
            initForm(res);
        };
        fetchPageContent();
    }, [shopId]);

    const initForm = (result) => {
        if(result.shareSmallImg) setShareSmallImg( [{url: result.shareSmallImg, thumbUrl: `${imageUrlPrefix}${result.shareSmallImg}?x-oss-process=image/resize,w_200`, name: '', type: "image/jpeg"}] );
        if(result.shareLargeImg) setShareLargeImg( [{url: result.shareLargeImg, thumbUrl: `${imageUrlPrefix}${result.shareLargeImg}?x-oss-process=image/resize,w_200`, name: '', type: "image/jpeg"}] );
        if(result.sharePosterImg) setSharePosterImg( [{url: result.sharePosterImg, thumbUrl: `${imageUrlPrefix}${result.sharePosterImg}?x-oss-process=image/resize,w_200`, name: '', type: "image/jpeg"}] );

        form.setFieldsValue({
            ...result,
        });
    };

    const getPageContent = async () => {
        const response = await fetch(`/api/page/get?shopId=${shopId}&pageId=${params.get('pageId')}`);
        const result = await response.json();

        if (result?.success) {
            return result.data;
        }
    };  

    const onSave = async () => { 
        const values = await form.validateFields();
        const url = window.location.pathname === '/mall/page/create' ? `/api/page/create` : `/api/page/update`;

        if(!!shareSmallImg){
            values.shareSmallImg = shareSmallImg[0]?.url || '';
        }
        if(!!shareLargeImg){
            values.shareLargeImg = shareLargeImg[0]?.url || '';
        }
        if(!!sharePosterImg){
            values.sharePosterImg = sharePosterImg[0]?.url || '';
        }
        
        if(pageContentRef.current || pageContentRef.current+'' === 'null') values.content = JSON.stringify(pageContentRef.current);
        if (!shopId) {
            message.error('店铺信息未加载完成');
            return;
        }
        values.shopId = shopId;

        // console.log('values=============>', pageContent, values); return;

        const response = await fetch(`${url}?pageId=${params.get('pageId')}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        });

        const result = await response.json();
        if(result?.success) {
            message.success('保存成功');
        }else {
            message.error(result.data);
        }
    };


    return (
        <div>
            {/* <SwitchShop /> */}
            {/* <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/shop" text="商城设置">
                    <HomeOutlined style={iconStyle} />
                </NavItem>
            </Row> */}
            <h2>页面编辑</h2>
            <Form form={form}>
                <Form.Item 
                    label="页面名称"
                    name={'title'}
                    rules={[{ required: true, message: '请输入页面名称' }]}
                > 
                    <Input />
                </Form.Item>

                <Form.Item 
                    hidden={true}
                    name={'code'}
                > 
                    <Input />
                </Form.Item>

                <Form.Item 
                    label="分享标题"
                    name={'shareTitle'}
                > 
                    <Input />
                </Form.Item>

                {/* <Form.Item 
                    label="分享描述"
                    name={'shareDescription'}
                > 
                    <Input />
                </Form.Item> */}

                <Form.Item 
                    label="分享小图"
                    name={'shareSmallImg'}
                    help="建议比例1:1，适用于H5分享微信好友及微信朋友圈"
                > 
                    <Upload
                        // name="avatar"
                        // defaultFileList={mainImages}
                        fileList={shareSmallImg}
                        listType="picture-card"
                        className="avatar-uploader"
                        maxCount={1}
                        action="/api/upload/image"
                        beforeUpload={beforeUpload}
                        onChange={(file) => handleChange('shareSmallImg', file)}
                    >
                        {imageUrl ? <img src={imageUrl + '?x-oss-process=image/resize,w_200'} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item 
                    label="分享大图"
                    name={'shareLargeImg'}
                    help="建议比例5:4，适用于小程序分享微信好友"
                > 
                    <Upload
                        // name="avatar"
                        // defaultFileList={mainImages}
                        fileList={shareLargeImg}
                        listType="picture-card"
                        className="avatar-uploader"
                        maxCount={1}
                        action="/api/upload/image"
                        beforeUpload={beforeUpload}
                        onChange={(file) => handleChange('shareLargeImg', file)}
                    >
                        {imageUrl ? <img src={imageUrl + '?x-oss-process=image/resize,w_200'} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                </Form.Item>

                {/* <Form.Item 
                    label="分享海报"
                    name={'sharePosterImg'}
                > 
                    <Upload
                        // name="avatar"
                        // defaultFileList={mainImages}
                        fileList={sharePosterImg}
                        listType="picture-card"
                        className="avatar-uploader"
                        maxCount={1}
                        action="/api/upload/image"
                        beforeUpload={beforeUpload}
                        onChange={(file) => handleChange('sharePosterImg', file)}
                    >
                        {imageUrl ? <img src={imageUrl + '?x-oss-process=image/resize,w_200'} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                </Form.Item> */}
            </Form>
            <Divider />
            {
                ((['custom', 'index'].includes(form.getFieldValue('code')) || window.location.pathname === '/mall/page/create') && pageCtn.load && shopId)? (
                    <div style={{marginLeft: 60}}>
                        <PageEditor
                            accId={window.__baseInfo.accId}
                            shopId={shopId}
                            list={pageCtn?.content?.tree || []}
                            onChange={data => pageContentRef.current = {tree: data}}
                        />
                    </div>
                ) : null
            }
            <Divider />
            <Space>
                <Button href='/mall'>返回</Button>
                <Button type="primary" onClick={onSave}>保存</Button>
            </Space>
        </div>
    );
};